import React, { useState } from 'react';
import Modal from 'react-modal';
import Styled from './styles';
import { useGlobalModalContext } from '../..';
import { Typography } from '../../../typography';
import MUIButton from '../../../mui-button';
import CloseIcon from "@material-ui/icons/Close";
import colors from "../../../../assets/colors";

export const ConnectCrmModal = () => {
	const { hideModal, store } = useGlobalModalContext();

	const [state, setState] = useState<any>({});

	const { modalProps } = store || {};
	const { item, confirmCallback } = modalProps || {};
	const { fields, logo, name } = item;

	const handleModalToggle = () => {
		hideModal();
	};

	const handleChange = (event: any, field: keyof typeof state): void => {
		setState((prev: any) => ({
			...prev,
			[field]: event.target.value,
		}));
	};

	return (
		<Modal
			isOpen={true}
			className={'Settings'}
			onRequestClose={handleModalToggle}
			shouldCloseOnEsc
			shouldCloseOnOverlayClick
		>
			<Styled.ModalContent>
				<Styled.Close onClick={handleModalToggle}>
					<CloseIcon style={{ color: colors.black }} />
				</Styled.Close>
				<div>
					{logo ? (
						<img src={logo} style={{ height: 100, marginBottom: 20, marginTop: 20 }} alt="" />
					) : (
						<Typography text={name} />
					)}
				</div>
				<div style={{ width: '100%' }}>
					{fields.map((field: string, i: number) => {
						const result = field.replace(/([A-Z])/g, " $1");
						const finalResultTitle = result.charAt(0).toUpperCase() + result.slice(1);
						return (
							<div
								key={i}
								style={{
									display: 'flex',
									flexDirection: 'column',
									marginTop: 10,
								}}
							>
								<Typography text={finalResultTitle} size="tiny" />
								<Styled.Input
									type="text"
									name={field}
									value={state[field]}
									onChange={event => handleChange(event, field)}
								/>
							</div>
						)
					})}
				</div>

				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						width: '100%',
						marginTop: 20,
					}}
				>
					<MUIButton
						title="Continue"
						disabled={Object.values(state).filter(el => el !== '').length < fields.length}
						callBack={() => {
							handleModalToggle();
							confirmCallback(state);
						}}
					/>
				</div>
			</Styled.ModalContent>
		</Modal>
	);
};
